var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelLineGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45996 1.875V0H14.5509V1.875H9.06223V7.45455H6.9486V1.875H1.45996ZM6.9486 10.4545H9.06223V17.4545H6.9486V10.4545ZM0 9.45459H16V8.45459H0V9.45459Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelLineGray);
export default __webpack_public_path__ + "static/media/Cancel_Line_Gray.f1212b3172d3b97a609fb8281eb4697f.svg";
export { ForwardRef as ReactComponent };